import React from "react";
import {useTheme} from "@mui/material";
import PropTypes from "prop-types";

const SAMLIcon = ({fontSize = 32, fontWeight, text = "SAML 2.0", x = "50%", y = "25%"}) => {
  const theme = useTheme();

  return (
    <svg data-testid="saml-icon" width={150} height={100}>
      <text
        x={x}
        y={y}
        dominantBaseline="middle"
        textAnchor="middle"
        fill={theme.palette.primary.main}
        fontSize={fontSize}
        fontWeight={fontWeight}
        fontFamily={theme.typography.fontFamily}
      >
        {text}
      </text>
    </svg>
  );
};

SAMLIcon.propTypes = {
  fontSize: PropTypes.number,
  fontWeight: PropTypes.number,
  text: PropTypes.string,
  x: PropTypes.string,
  y: PropTypes.string,
};

export default SAMLIcon;
